import React from 'react';

import { Box } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { DataGrid, GridColDef, GridPaginationModel, GridRowParams, GridSortDirection } from '@mui/x-data-grid';

import { BUSINESS_TRAVELLER_ROLES as RoleMap } from '~/consts/businessTravellerRoles';

const columns: Array<GridColDef> = [
  { field: 'id', headerName: 'ID', width: 380, display: 'flex' },
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
    renderCell: (params) => `${params.row.firstName} ${params.row.lastName}`,
    display: 'flex',
  },
  { field: 'email', headerName: 'Email', width: 350, display: 'flex' },
  {
    field: 'roles',
    headerName: 'Roles',
    width: 200,
    display: 'flex',
    renderCell: (params) => `${RoleMap[params.row.roles]}`,
    sortComparator: (v1, v2) => {
      const role1 = RoleMap[v1] || '';
      const role2 = RoleMap[v2] || '';
      return role1.localeCompare(role2);
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
    display: 'flex',
    sortable: true,
    renderCell: (params) => params.row.status || '',
    sortComparator: (v1, v2) => {
      const status1 = v1 || '';
      const status2 = v2 || '';
      return status1.localeCompare(status2);
    },
  },
];

const sortModel = [
  {
    field: 'roles',
    sort: 'asc' as GridSortDirection,
  },
];

interface Props {
  onPaginationModelChange: any;
  paginationModel: GridPaginationModel;
  rows: Array<App.BusinessEmployee>;
  total: number;
}

export default function EmployeesGrid({ onPaginationModelChange, paginationModel, rows, total }: Props) {
  function handleRowClick(row: App.BusinessEmployee) {
    const url = `/users/${row.customerId}`;

    window.open(url, '_blank');
  }

  return (
    <Grid2 size={12}>
      <Box width="100%" height={600}>
        <DataGrid
          columns={columns}
          onPaginationModelChange={onPaginationModelChange}
          onRowClick={(row: GridRowParams<App.BusinessEmployee>) => handleRowClick(row.row)}
          paginationMode="server"
          paginationModel={paginationModel}
          rows={rows || []}
          rowCount={total}
          sortModel={sortModel}
        />
      </Box>
    </Grid2>
  );
}
